<template>
    <div class="flex rounded text-xs leading-3 p-1 pl-2 pr-2 justify-center" :style="`background-color: ${bgColor};`">
            <slot></slot>
    </div>
</template>

<script lang="ts" setup>

defineProps({
    bgColor:{
        type: String,
        default: '#f8f8f8'
    }
})

</script>

<style scoped>

</style>